import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Check = createSvgIcon(
  () => (
    <path d="M16.9434 36.5723C17.9199 37.5488 19.5801 37.5488 20.5566 36.5723L49.2676 7.86133C50.2441 6.88477 50.2441 5.22461 49.2676 4.24805L45.752 0.732422C44.7754 -0.244141 43.2129 -0.244141 42.2363 0.732422L18.7988 24.1699L7.76367 13.2324C6.78711 12.2559 5.22461 12.2559 4.24805 13.2324L0.732422 16.748C-0.244141 17.7246 -0.244141 19.3848 0.732422 20.3613L16.9434 36.5723Z" />
  ),
  '0 0 50 38',
  'Check'
);
